module.exports = __webpack_public_path__ + "static/media/dH20-empty.65ce7c11.svg";